import { fg } from '@atlaskit/platform-feature-flags';
import { safeWarnWithoutCustomerData } from './utils';
var idTypeMap = new Map();
export default function RelayDataID(fieldValue, typeName) {
  var id = fieldValue.id;
  if (id == null) {
    return undefined;
  }
  if (fg('platform_log_relay_duplicate_identifiers')) {
    var idString = String(id);
    if (idTypeMap.has(idString)) {
      var entry = idTypeMap.get(idString);
      if (entry) {
        var existingTypeName = entry.typeName,
          hasLoggedConflict = entry.hasLoggedConflict;
        if (existingTypeName !== typeName && !hasLoggedConflict) {
          safeWarnWithoutCustomerData('relaydataid.generator', "RelayDataID: conflicting type names for the same ID: ".concat(idString, " with type names: ").concat(existingTypeName, " and ").concat(typeName, "."), {
            id: idString,
            types: "".concat(existingTypeName, ", ").concat(typeName)
          });
          entry.hasLoggedConflict = true;
        }
      }
    } else {
      idTypeMap.set(idString, {
        typeName: typeName,
        hasLoggedConflict: false
      });
    }
  }
  return "".concat(String(id), ":::::").concat(typeName);
}